import {Component, OnDestroy, OnInit} from '@angular/core';
import {concat, Observable, of, Subscription} from 'rxjs';
import {debounceTime, delay, distinctUntilChanged, filter, map, scan, switchMap} from 'rxjs/operators';
import {LoaderRequestService} from '@app/service/loader-request.service';
import {LoaderState} from '@app/domain/loader-state';
import {NgxUiLoaderService} from 'ngx-ui-loader';

@Component({
    selector: 'app-loader',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.css']
})
export class LoaderComponent implements OnInit, OnDestroy {
    // Barra superior para peticiones background (GET):
    // 'loading' = avanza lento hacia ~90%, 'finishing' = corre al 100% y se desvanece, null = oculta
    barState$: Observable<string | null>;
    private subscription: Subscription;
    constructor(private loaderService: LoaderRequestService,
                private ngxService: NgxUiLoaderService) { }
    ngOnInit() {
        this.barState$ = this.loaderService.loaderState.pipe(
            filter((state: LoaderState) => state.background),
            scan((activas: number, state: LoaderState) => Math.max(0, activas + (state.show ? 1 : -1)), 0),
            map((activas: number) => activas > 0),
            distinctUntilChanged(),
            switchMap((cargando: boolean) => cargando
                ? of('loading')
                : concat(of('finishing'), of(null).pipe(delay(600)))),
            debounceTime(0)
        );
        this.subscription = this.loaderService.loaderState
            .subscribe((state: LoaderState) => {
                if (!state.background) {
                    if (state.show) {
                        this.ngxService.start();
                    } else {
                        this.ngxService.stop();
                    }
                }
            });
    }
    ngOnDestroy() {
        this.subscription.unsubscribe();
    }
}
